import { IonRow, IonButton, IonCol, IonInput, IonIcon } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import API from '../../api/index';
import { connect } from 'react-redux';
import { fetchButtonVariables } from '../../store';
import { RootState } from '../../models/RootState';
import { ButtonVariable } from '../../models/ButtonVariables';
import NumberFormat from 'react-number-format';
import Spinner from '../../components/Spinner/Spinner';
import './ButtonVariables.scss';
import RightSideNav1 from '../../views/CommissionRules/RightSideNav/RightSideNav1';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import savebtn from '../../assets/images/common/savebtn.svg';
import API_V2 from '../../api-services/svls-api';
type StoreProps = {
  buttonVariables: ButtonVariable[];
  fetchButtonVariables: () => void;
};

const MyBets: React.FC<StoreProps> = (props) => {
  const { buttonVariables, fetchButtonVariables } = props;
  const [successMsg, setSuccessMsg] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [updateVariables, setUpdateVariables] = useState<ButtonVariable[]>();

  useEffect(() => {
    setTimeout(() => {
      setErrorMsg('');
    }, 2000);
  }, [errorMsg]);

  const updateButtonVariables = async () => {
    setLoading(true);
    for (let uV of updateVariables) {
      if (!uV.label || !uV.stake) {
        setErrorMsg('Label or Amount invalid');
        return 0;
      }
    }
    const response = await API_V2.put(
      '/catalog/v2/settings/favourite-stakes/users', updateVariables, {
      headers: {
        Authorization: sessionStorage.getItem('jwt_token'),
      },
    });
    if ((response.status = 200)) {
      setSuccessMsg('Button variables saved successfully.');
    } else {
      setErrorMsg('Something went wrong');
    }
    fetchButtonVariables();
    setLoading(false);
  };

  useEffect(() => {
    fetchButtonVariables();
  }, []);

  useEffect(() => {
    setUpdateVariables(buttonVariables);
  }, [buttonVariables]);

  const updateButtonLabel = (index: number, label: string) => {
    const updateBtnVars = [...updateVariables];
    updateBtnVars[index].label = label;
    setUpdateVariables(updateBtnVars);
  };

  const updateButtonAmount = (index: number, amt: number) => {
    const updateBtnVars = [...updateVariables];
    updateBtnVars[index].stake = amt;
    setUpdateVariables(updateBtnVars);
  };

  return (
    <div className="report-page">
      <IonRow>
        <IonCol sizeMd="1.7" sizeLg="1.7" className="web-view">
          <div className="compt-menu-section">
            <div className="sticky-col">
              <CompetitionsMenu loggedIn={true} />
            </div>
          </div>
        </IonCol>
        <IonCol sizeXs="12" sizeSm="12" sizeMd="8.3" sizeLg="8.3">
          <div className="reports-ctn">
            {loading ? <Spinner /> : null}
            <div className="carw">
              <div className="arrow arrow-right">Set Button Stake</div>
            </div>
            <div className="btn-ctn web-view">
              <IonButton
                className="save-btn"
                onClick={() => updateButtonVariables()}
              >
                <IonIcon src={savebtn} className="icon" />
                Save
              </IonButton>
            </div>
            <div className="card-button-ctn">
              <IonRow className="label-row">
                <IonCol
                  sizeXl="6"
                  sizeLg="6"
                  sizeMd="6"
                  sizeSm="6"
                  sizeXs="6"
                  className="btn-var-label-col"
                >
                  Label
                </IonCol>
                <IonCol
                  className="btn-var-label-col"
                  sizeXl="6"
                  sizeLg="6"
                  sizeMd="6"
                  sizeSm="6"
                  sizeXs="6"
                >
                  Value
                </IonCol>
              </IonRow>
              {buttonVariables.map((bV, idx) => (
                <IonRow key={'btn-var-row' + idx} className="btn-var-row">
                  <IonCol
                    key={'btn-var-label-col' + idx}
                    sizeXl="6"
                    sizeLg="6"
                    sizeMd="6"
                    sizeSm="6"
                    sizeXs="6"
                    className="btn-var-label-col"
                  >
                    <IonInput
                      key={'btn-var-label-input' + idx}
                      type="text"
                      value={bV.label}
                      className="btn-var-label-input"
                      onIonChange={(e) =>
                        updateButtonLabel(idx, e.detail.value)
                      }
                      debounce={500}
                    ></IonInput>
                  </IonCol>

                  <IonCol
                    key={'btn-var-amt-col' + idx}
                    sizeXl="6"
                    sizeLg="6"
                    sizeMd="6"
                    sizeSm="6"
                    sizeXs="6"
                  >
                    <NumberFormat
                      key={'btn-var-num-input' + idx}
                      value={bV.stake}
                      className="btn-var-num-input"
                      allowNegative={false}
                      style={{
                        padding: '10px',
                        width: '100%',
                      }}
                      onValueChange={(e) =>
                        updateButtonAmount(idx, e.floatValue)
                      }
                    ></NumberFormat>
                  </IonCol>
                </IonRow>
              ))}

              <IonRow>
                <IonCol
                  sizeXl="8"
                  sizeLg="8"
                  sizeMd="8"
                  sizeSm="12"
                  sizeXs="12"
                >
                  {errorMsg !== '' ? (
                    <div className="err-section">
                      <div className="err-box">
                        <div className="msg">{errorMsg && errorMsg}</div>
                      </div>
                    </div>
                  ) : null}
                  {successMsg !== '' ? (
                    <div className="err-section">
                      <div className="success-box">
                        <div className="msg">{successMsg && successMsg}</div>
                      </div>
                    </div>
                  ) : null}
                </IonCol>
              </IonRow>
              <div className="btn mob-view">
                <IonButton
                  className="save-btn"
                  onClick={() => updateButtonVariables()}
                >
                  <IonIcon src={savebtn} className="icon" />
                  Save Changes
                </IonButton>
              </div>
            </div>
          </div>
        </IonCol>

        <IonCol sizeMd="2" sizeLg="2" className="web-view">
          <div className="compt-menu-section">
            <RightSideNav1 />
          </div>
        </IonCol>
      </IonRow>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    buttonVariables: state.exchBetslip.buttonVariables,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchButtonVariables: () => dispatch(fetchButtonVariables()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyBets);
